<template>
	<section class="app-container">
		<div class="container" v-if="!loading">
			<span v-if="is_certified" class="label label--inline pull-right">Certified Observer</span>
			<h1>{{user.display_name}} Profile</h1>
			<div class="row">
				<div class="col-md-9">
					<router-link class="btn btn--xs pull-right" :to="{ path: '/data/records/', query: { filterqs: '|users:' + user.id }}">View All</router-link>
					<h4>Recent Sightings</h4>
					<Loader v-show="records_loading" />
					<div class="min-records" v-show="!records_loading">
						<RecordsList v-model="records" :meta="records_meta" hideUser="true" hideStatus="true" hideVetted="true"></RecordsList>
					</div>
				</div>
				<div class="col-md-3">
					<router-link class="btn btn--xs pull-right" :to="{ path: '/data/checklists/', query: { filterqs: '|users:' + user.id }}">View All</router-link>
					<h4>Recent Checklists</h4>
					<Loader v-show="checklists_loading" />
					<ul v-show="!checklists_loading">
						<li v-for="checklist in checklists" v-if="checklist.datetime">
							<router-link :to="{ name: 'checklist_view', params: { id: checklist.id }}">
								{{ checklist.datetime.split('T')[0] | moment(momentDisplayFormat()) }} @ <span class="notranslate" translate="no">{{checklist.location_data.display_name}}</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'ProfilePage',
    metaInfo() {
    	return {
	      title: this.meta_title,
	      meta: [
	        { name: "description", content: this.meta_description },
	      ],
	    }
	  },
	data: function(){
		return {
			loading: true,
			user: null,
			groups: null,
			records: null,
			records_loading: true,
			records_meta: null,
			checklists: null,
			checklists_loading: true,
			is_certified:false,
      		meta_title: "User Profile",
		    meta_description: "User Profile",
		};
	},
	mounted(){
		this.bind_profile();
	},
	methods:{
		bind_profile: function(){
			var self = this;
			var qs = "&include[]=groups.*";
			this.API({
				endpoint: 'users/' + this.$route.params.id,
				querystring: qs,
				funcThen: function(response){
					self.user = response.data.user;
					self.is_certified = false;
					if (self.user.groups) {
						self.is_certified = self.user.groups.find(u => u.name = "Certified Observer") != null;
					}
					self.groups = response.data.groups
					self.loading = false;
					self.getSightings();
					self.getChecklists();

					self.meta_title = self.user.display_name + " Profile";
					self.meta_description = "Dragonfly and Odonate sightings and observations by " + self.user.display_name;
				},
			});
		},
		getChecklists: function(){
			var self = this;
			var qs = "&filter{user.id}=" + self.user.id;
			qs += "&include[]=location.*";
			qs+="&sort[]=-id";
			this.API({
				endpoint: 'checklists',
				querystring: qs,
				funcThen: function(response){
					self.checklists = self.combineSightingData(response.data);
				},
		        funcAfterThen: function(){
		          self.checklists_loading = false;
		        }
			});
		},
		getSightings: function(){
			var self = this;
			var qs = "&include[]=checklist.user.*";
			qs += "&include[]=checklist.location.*";
			qs += "&include[]=checklist.location.parent.*";
			qs += "&include[]=status.*";
			qs += "&include[]=checklist.*";
			qs += "&include[]=taxon.*";
			qs += "&filter{checklist.user.id}=" + self.user.id;
			qs+="&sort[]=-id";

			this.API({
				endpoint: 'sightings',
				querystring: qs,
				funcThen: function(response){
					self.records_meta = response.data.meta;
					self.records = self.CombineSightingData(response.data);
				},
		        funcAfterThen: function(){
		          self.records_loading = false;
		        }
			});
		},
		combineSightingData: function(data){
        	for (var i = 0; i < data.checklists.length; i++) {
		        data.checklists[i].location_data = data.locations.find(u => u.id == data.checklists[i].location);
		    }
		    return data.checklists;
        }
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Profile.vue